<template>
  <div>
    <ModelForm
      :ref="ref_model_form"
      :model_name="model_name"
      @persist="on_persist"
      @close="on_clean"
      @erase="on_erase"
      form_title_overload="Connect Live Broker or Connect Paper Broker"
    >
      <template v-slot:model_form="mProps">
        <v-container v-if="edited_item">
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="edited_item.name"
                label="Name"
                hint="Just a Reference name for this node broker."
                :rules="[rules.required]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-img
                :aspect-ratio="16 / 9"
                :src="B.get_broker(edited_item.broker_type)?.img"
              >
              </v-img>
            </v-col>
          </v-row>
          <v-row v-if="!mProps.is_new">
            <v-col cols="12" sm="6" md="4">
              <v-checkbox
                v-model="edited_item.is_active"
                label="Active"
                hint="some"
              ></v-checkbox>
            </v-col>
          </v-row>
          <v-row v-if="B.is_interactive_broker(edited_item.broker_type)">
            <v-col cols="12" md="6">
              <v-combobox
                v-model="edited_item.config_json.ib_trading_mode"
                :items="B.get_trading_modes()"
                label="Trading Mode"
                hint="Trading mode for this instance."
                :rules="[rules.required]"
              >
                ></v-combobox
              >
            </v-col>
            <v-col cols="12">
              * If you're connecting for the first time, please enter your
              username and password. For updates to the connection status, name,
              or trading mode, you may leave the username and password fields
              blank.
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="edited_item.config_json.ib_username"
                label="Username"
                hint="Username of the IB account."
                :rules="[
                  !mProps.is_new ? () => true : rules.required,
                  rules.no_spaces,
                ]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="edited_item.config_json.ib_password"
                label="Password"
                hint="Password of the IB account."
                :rules="[
                  !mProps.is_new ? () => true : rules.required,
                  rules.no_spaces,
                ]"
                :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                :type="show1 ? 'text' : 'password'"
                filled
                @click:append="show1 = !show1"
              >
                ></v-text-field
              >
            </v-col>
          </v-row>
          <v-row v-if="is_tradovate(edited_item)">
            <v-col cols="12" md="6">
              <v-combobox
                v-model="edited_item.config_json.tradovate_session_type"
                :items="B.get_session_type_modes()"
                label="Trading Mode"
                hint="Trading mode for this session."
                :rules="[rules.required]"
              >
                ></v-combobox
              >
            </v-col>
            <v-col cols="12" md="6" v-if="!mProps.is_new">
              <v-select
                v-model="edited_item.config_json.misfire"
                :items="[
                  { name: 'Activated', value: true },
                  { name: 'Deactivated', value: false },
                ]"
                label="Misfire Status"
                :hint="misfire_dynamic_hint"
                item-text="name"
                item-value="value"
                persistent-hint
                clearable
              ></v-select>
            </v-col>
            <v-col cols="12">
              For your security, you'll be redirected to Tradovate's secure
              OAuth login. This is a highly secure authentication method that
              protects your account information by preventing unauthorized
              access.
            </v-col>
          </v-row>
        </v-container>
      </template>
      <template v-slot:model_view>
        <v-container v-if="edited_item">
          <v-row>
            <v-col cols="12" md="12">
              <v-combobox
                v-model="edited_item.name"
                label="Name"
                disabled
              ></v-combobox>
              <v-text-field
                v-model="edited_item.is_active"
                label="Active"
                disabled
              ></v-text-field>
            </v-col>
          </v-row>
        </v-container>
      </template>
    </ModelForm>
    <v-btn color="primary" class="mb-2" @click="create_item"> + </v-btn>
  </div>
</template>

<script>
import Vuex from "vuex";

import inputRules from "@/mixins/inputRules.js";
import ModelForm from "@/components/helpers/ModelFormV1.vue";
import cudForm from "@/mixins/cudFormV2.js";
import B from "@/mixins/brokerConstants.js";
import tradovate from "@/mixins/tradovateAPI.js";

export default {
  name: "NodeBrokerCud",
  mixins: [cudForm, inputRules],
  components: { ModelForm },
  props: [],
  data() {
    return {
      model_name: "Node Broker",
      show1: false,
      brokers: B.get_brokers(),
      empty_object: {
        broker_type: null,
        name: null,
        is_active: true,
        config_json: null,
      },
      tradovate: tradovate,
      debug: false,
      B: B,
    };
  },
  methods: {
    async tradovate_oauth(item) {
      let referer = this.T.get_referer();
      var path = `${this.apip.API_TRADOVATE_AUTH_PATH}?referer=${referer}`;
      var response = await this.pyx_api.post(path, item);
      if (this.debug) console.log(response.data);
      window.location.href = response.data.url;
      return item;
    },
    async actual_create_item(item) {
      if (this.is_tradovate(item)) {
        item.id = 0;
        await this.tradovate_oauth(item);
      } else {
        var path = `${this.apip.API_NODE_BROKERS_PATH}`;
        var response = await this.pyx_api.post(path, item);
        return response.data;
      }
    },
    async actual_update_item(item) {
      if (this.is_tradovate(item)) {
        delete item.config_json.tradovate_accounts;
        delete item.config_json.tradovate_token_id;
      }
      var path = `${this.apip.API_NODE_BROKERS_PATH}/${item.id}`;
      if (this.debug) console.log(item);
      var response = await this.pyx_api.put(path, item);
      return response.data;
    },
    post_update_item(original_item, updated_item) {
      if (this.debug) console.log(updated_item);
      this.show_info_message({ message: `Updated ${this.model_name}.` });
      this.$emit("updated_item", original_item, updated_item);
      if (this.is_tradovate(updated_item)) {
        if (updated_item.config_json?.requires_token) {
          this.tradovate_oauth(updated_item);
          return;
        }
      }
    },
    async actual_delete_item(item) {
      var path = `${this.apip.API_NODE_BROKERS_PATH}/${item.id}`;
      await this.pyx_api.delete(path);
      return item;
    },
    preset_config_json(item) {
      if (item.broker_type == this.B.BROKER_TYPES.PROTERYX_TERMINAL_US) {
        if (!item.config_json)
          item.config_json = { ib_username: null, ib_password: null };
      } else {
        if (!item.config_json) item.config_json = { misfire: false };
      }
    },
    create_item(broker_type) {
      this.edited_item = this.T.copy(this.empty_object);
      this.edited_item.broker_type = broker_type;
      this.preset_config_json(this.edited_item);
      this.$refs[this.ref_model_form].open_edit(true);
    },
    edit_item(item) {
      this.edited_item = this.T.copy(item);
      this.preset_config_json(this.edited_item);
      if (this.debug) console.log(this.edited_item);
      this.$refs[this.ref_model_form].open_edit(false);
    },
    is_tradovate(broker) {
      return (
        broker?.broker_type == this.B.BROKER_TYPES.TRADOVATE_DIRECT_MULTIPLE
      );
    },
    ...Vuex.mapActions(["show_error_message", "show_info_message"]),
  },
  watch: {
    "edited_item.broker_type"(nval) {
      if (nval) this.preset_config_json(this.edited_item);
    },
  },
  computed: {
    misfire_dynamic_hint() {
      if (this.edited_item?.config_json) {
        if (this.edited_item.config_json.misfire == undefined) {
          return "";
        } else if (!this.edited_item.config_json.misfire) {
          return `You'll be able to place trades automatically or manually using this platform.`;
        } else {
          return `You'll need to place trades directly with your broker, not through this platform.`;
        }
      }
    },
  },
};
</script>
